import { JsonPlaceholderService } from '../autorizaciones/services/json-placeholder.service';
import { NgModule } from '@angular/core';
import { ProcedimientosTupaRoutingModule } from './procedimientos-tupa-routing.module';
import { TupaService } from './services/tupa.service';
import { TransversalService } from '@app/core/services/transversal.service';
import { HttpClientModule } from '@angular/common/http';
import { MatStepperModule, MatFormFieldModule } from '@angular/material';
import { MensajeDisponibilidadComponent } from './pages/mensaje-disponibilidad/mensaje-disponibilidad.component';

@NgModule({
  declarations: [
    
  ],
  imports: [
    ProcedimientosTupaRoutingModule,
    HttpClientModule,
    MatStepperModule,
    MatFormFieldModule
  ],
  providers: [    
    TupaService,
    TransversalService,
    JsonPlaceholderService
  ]  
})
export class ProcedimientosTupaModule { }


